import React, { createContext, useContext, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { handleGetSessionStorage } from "../../../services/helpers";

const TerminalContext = createContext();

function useTerminalContext() {
  return useContext(TerminalContext);
}

const TerminalProvider = ({ children }) => {
  const { addToast } = useToasts();
  const { company } = handleGetSessionStorage();
  const initialForm = {
    empresa: company,
    numeroCartao: "",
    valorTotal: 0,
    outrosValores: 0,
    numeroParcelas: 0,
    senha: "",
    idAcRedeCredenciadaRepr: 0,
    consultaMedica: [],
    procedimentoMedico: [],
    nome: "",
  };

  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [activeNav, setActiveNav] = useState("consulta");
  const [numeroParcelas, setNumeroParcelas] = useState(0);
  const [visible, setVisible] = useState(false);
  const [transaction, setTransaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [aceitaValores, setAceitaValores] = useState(false);

  function handleChange(value) {
    setForm({ ...form, ...value });
  }

  function clearFilter() {
    setAceitaValores(false);
    setDisabled(false);
    setForm(initialForm);
    setNumeroParcelas(0);
    setActiveNav("consulta");
    setErrors({});
    setTransaction(false);
    setData({});
  }

  const successMessage = (message, fn = () => {}) => {
    addToast(
      message,
      {
        appearance: "success",
        autoDismiss: true,
      },
      fn
    );
  };

  const warningMessage = (message) => {
    addToast(message, {
      appearance: "warning",
      autoDismiss: true,
    });
  };

  const infoMessage = (message) => {
    addToast(message, {
      appearance: "info",
      autoDismiss: true,
    });
  };

  const errorMessage = (message) => {
    addToast(message, {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const value = {
    initialForm,
    form,
    setForm,
    errors,
    setErrors,
    handleChange,
    successMessage,
    warningMessage,
    errorMessage,
    activeNav,
    setActiveNav,
    infoMessage,
    numeroParcelas,
    setNumeroParcelas,
    clearFilter,
    visible,
    setVisible,
    transaction,
    setTransaction,
    loadingButton,
    setLoadingButton,
    loading,
    setLoading,
    data,
    setData,
    disabled,
    setDisabled,
    aceitaValores,
    setAceitaValores,
  };
  return (
    <TerminalContext.Provider value={value}>
      {children}
    </TerminalContext.Provider>
  );
};

export { useTerminalContext, TerminalProvider };
